import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { Link as MuiLink } from '@mui/material';

import {
  type MarketingRouterTreatmentType,
  getMarketingRouterTreatmentConfig,
} from '@luxuryescapes/contract-svc-promo/marketing-router/admin';

type Treatment = {
  type: MarketingRouterTreatmentType;
  channelMarkupId?: string;
};

export function formatTreatments(treatments?: Array<Treatment>): React.ReactNode {
  if (!treatments?.length) {
    return '—';
  }

  return treatments.map((treatment, index) => {
    const treatmentName = getMarketingRouterTreatmentConfig(treatment.type)?.typeName ?? treatment.type;
    const treatmentLabel =
      treatment.type === 'channel-markup' && treatment.channelMarkupId ? (
        <MuiLink
          component={Link}
          to={`/marketing/channel-markup-v2/${encodeURIComponent(treatment.channelMarkupId)}/edit`}
          underline="hover"
        >
          {treatmentName}
        </MuiLink>
      ) : (
        treatmentName
      );

    return (
      <React.Fragment key={`${treatment.type}-${treatment.channelMarkupId ?? index}`}>
        {index > 0 ? ', ' : null}
        {treatmentLabel}
      </React.Fragment>
    );
  });
}
